"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipSnapSelector = void 0;
var constants_1 = require("../../../../specs/constants");
var settings_1 = require("../../../../specs/settings");
var create_selector_1 = require("../../../../state/create_selector");
var get_settings_specs_1 = require("../../../../state/selectors/get_settings_specs");
exports.getTooltipSnapSelector = (0, create_selector_1.createCustomCachedSelector)([get_settings_specs_1.getSettingsSpecSelector], getTooltipSnap);
function getTooltipSnap(settings) {
    var _a;
    var tooltip = settings.tooltip;
    return tooltip && (0, settings_1.isTooltipProps)(tooltip) ? (_a = tooltip.snap) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_TOOLTIP_SNAP : constants_1.DEFAULT_TOOLTIP_SNAP;
}
//# sourceMappingURL=get_tooltip_snap.js.map